export enum FkAuthLevel {
	ROOT = 'root',
	FIRSTROI = 'firstroi',
	CLIENT = 'client'
}